import React, { useEffect, useMemo } from 'react';
import { ListCardBone, SkeletonLoader } from '@europrocurement/flexy-components';
import {
    DossierFacturation,
    useCollectionBillingCtx,
    useLazyDataLoader,
} from '@europrocurement/l2d-modules';
import { useParams } from 'react-router';
import BillingAddressSection from './components/BillingAddressSection/BillingAddressSection';
import QuoteAndBillsSection from './components/QuoteAndBillsSection/QuoteAndBillsSection';

type FacturationTabProps = {
    initialCollectionsIds?: number[];
};
const FacturationTab: React.FunctionComponent<FacturationTabProps> = function ({
    initialCollectionsIds,
}) {
    const { idsOrders } = useParams();
    const collectionsIds = useMemo(
        () => (initialCollectionsIds || (idsOrders ? JSON.parse(idsOrders) : [])) as number[],
        [initialCollectionsIds, idsOrders],
    );

    const {
        isInvoicesLoaded: invoiceDataLoaded,
        isEstimatesLoaded: estimateDataLoaded,
        isCollectionsLoaded,
    } = useCollectionBillingCtx();
    const { loadCollectionInvoices, loadCollectionEstimates, loadCollections } =
        useLazyDataLoader();

    useEffect(() => {
        if ((collectionsIds || []).length > 0) {
            loadCollectionInvoices(collectionsIds as number[]);
            loadCollectionEstimates(collectionsIds as number[]);
            loadCollections(collectionsIds as number[]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collectionsIds]);

    const loading = !invoiceDataLoaded() || !estimateDataLoaded() || !isCollectionsLoaded();

    return (
        <SkeletonLoader
            isLoading={loading}
            skeleton={
                <ListCardBone
                    itemCount={5}
                    contentHeight="220px"
                    gap="16px"
                />
            }
        >
            <BillingAddressSection collectionIds={collectionsIds as number[]} />
            <QuoteAndBillsSection collectionIds={collectionsIds as number[]} />
            <DossierFacturation />
        </SkeletonLoader>
    );
};

export default FacturationTab;
